/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_Template_LabelInputs */



/**
* | output |
* | --- |
* | "Add selected event to templates" |
*
* @param {Context_Menu_Event_Template_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_template_label = /** @type {((inputs?: Context_Menu_Event_Template_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_Template_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter l'événement sélectionné aux modèles")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge das ausgewählte Ereignis zu den Vorlagen hinzu")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi l'evento selezionato ai modelli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Добавить выбранное событие в шаблоны")
	if (locale === "es") return /** @type {LocalizedString} */ ("Agregar evento seleccionado a las plantillas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将选定事件添加到模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントをテンプレートに追加")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट को टेम्प्लेट में जोड़ें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Adicionar o evento selecionado aos modelos")
	return /** @type {LocalizedString} */ ("Add selected event to templates")
});